export default function TravelCardSkeleton() {
  return (
    <div>
      <div className='w-full aspect-[154/100] skeleton-item rounded-6pxr mb-6pxr'></div>
      <div className='w-2/3 h-20pxr skeleton-item rounded-2pxr'></div>
    </div>
  );
}
